import { Component, OnInit, OnChanges, OnDestroy, Input, Output, EventEmitter} from '@angular/core';
import { ConfigService } from '../../services/config/config.service';
import { SmartContractService } from '../../services/smart-contract/smart-contract.service';
import { InvoiceService } from '../../services/invoice/invoice.service';
import { TimesheetService } from '../../services/timesheet/timesheet.service';
import { CommsService } from '../../services/comms/comms.service';
import { NoteService } from '../../services/note/note.service';
import { TableFilter, TableFilterService } from '../../services/table-filter/table-filter.service';

@Component({
	selector: 'pcm-modal-form-migrate-po',
	templateUrl: './modal-form-migrate-po.component.html',
	styleUrls: [
		'../modal-form/modal-form.component.scss',
		'./modal-form-migrate-po.component.scss',
	]
})
export class ModalFormMigratePoComponent implements OnInit, OnChanges, OnDestroy {

	@Output() modalSubmit: EventEmitter<any> = new EventEmitter();

	modalVisible = false;
	dataConfig;
	modalProp = '';
	formData = {};
	relatedData = [];
	selectedTableRows = [];

	columnsTS = [];
	columsINV = [];

	title = '';

	POs = [];
	showConfirmationModal = false;
	pageSize = 5;

	// this form is to support the popup fired by bulk table actions
	constructor(
		private commsService: CommsService,
		public configService: ConfigService,
		public smartContractService: SmartContractService,
		public timesheetService: TimesheetService,
		public noteService: NoteService,
		public invoiceService: InvoiceService,
		private tableFilterService: TableFilterService
	) { }

	ngOnInit() {
		console.log('Migrate PO MODAL FORM INIT');
		this.columnsTS = this.configService.getTableFields(this.timesheetService.dataObj, true);
		this.columsINV = this.configService.getTableFields(this.invoiceService.dataObj, true);
	}

	ngOnChanges(event) {
	}

	ngOnDestroy() {
		this.clearFormData();
	}

	showModal(basicData, scDataObj, relatedData) {
		console.log('SHOW MODAL', basicData, scDataObj, relatedData);
		this.clearFormData();
		const formConfig = this.configService.getDataObj(scDataObj);
		this.modalProp = basicData.prop;
		this.relatedData = relatedData;
		this.dataConfig = this.smartContractService.getSCConfig(formConfig, this.modalProp);

		this.title = this.dataConfig.name;
		const dataForPOMigrate = {};
		this.invoiceService.activePO = '';

		// load the payload for timesheets and invoice records
		if (relatedData && relatedData.length > 0) {
			this.title += ': ' + relatedData[0]['ponumber'];
			this.invoiceService.activePO = relatedData[0]['ponumber'];

			this.tableFilterService.removeAllFiltersFromTab(this.timesheetService.tabsData.poListTabs[0].tableFilters);

			const searchField: TableFilter = {
				propName: 'ponumber',
				value: relatedData[0]['ponumber']
			};
			this.tableFilterService.addFilter(this.timesheetService.tabsData.poListTabs[0].tableFilters, searchField);

			dataForPOMigrate['ponumber'] = relatedData[0]['ponumber'];
			dataForPOMigrate['supplierid'] = relatedData[0]['supplierid'];
		}

		this.populateModalForm();
		// load target POs
		const self = this;
		this.POs = [];
		this.commsService.getPOListForMigration(dataForPOMigrate).subscribe((res) => {
			console.log('LOAD POS RES: ', res);
			const successData = self.commsService.getSuccessData(res);
			if (successData['ponumbers'] && Array.isArray(successData['ponumbers'])) {
				successData['ponumbers'].forEach((po) => {
					self.POs.push({ponumber: po});
				});
			}

			if (this.POs.length === 0) {
				this.noteService.displayError('No target purchase orders are found for migration.');
				this.modalVisible = false;
			} else {
				this.modalVisible = true;
			}
		}, (err) => {
			console.log('Error occurred when retrieving target purchase orders for migration.');
			self.commsService.handleAPIError('Retrieve Target POs', err);
			this.modalVisible = false;
		});

		// load tables
		this.timesheetService.tabsData.poListTabs[0]['pageSize'] = this.pageSize;
		this.invoiceService.tabsData.cancelledPOListTabs[0]['pageSize'] = this.pageSize;
		this.timesheetService.selectDefaultTab(this.timesheetService.tabsData.poListTabs);
		this.invoiceService.selectDefaultTab(this.invoiceService.tabsData.cancelledPOListTabs);

		console.log('SHOW MODAL', this.modalProp, this.dataConfig, this.formData);
	}

	tableClick(event) {
		console.log('MODAL TABLE CLICK: ', event);
	}

	tableSelect(event) {
		console.log('MODAL TABLE SELECT: ', event, this.selectedTableRows);
	}

	tablePage(event) {
		console.log('MODAL TABLE PAGE: ', event);
	}

	clearFormData() {
		this.formData = {};
	}

	formCancel(event) {
		this.modalVisible = false;
	}

	formSubmit() {
		console.log('FORM SUBMIT', event);
		const modalEvent = {
			prop: this.modalProp,
			data: this.formData
		};
		this.modalSubmit.emit(modalEvent);
		const self = this;
		const delay = setTimeout(function () {
			self.cancelConfirmationModal();
		}, 1000);
	}

	populateModalForm() {
		console.log('MODAL FORM CONFIG', this.dataConfig, this.relatedData);

		const modalFormData = {};
		const self = this;

		// for each of the data config nested objects
		self.dataConfig.objects.forEach(function (dataObj, dataObjI) {
			console.log('POPULATE MODAL FORM OBJECT', dataObj.prop);
			// create an array using the nested object's prop param
			modalFormData[dataObj.prop] = [];

			// then loop through each item in the related data array (selected table rows)
			self.relatedData.forEach(function (relatedItem, relatedItemI) {

				// create an empty object to populate with the autopop params
				const relatedItemData = {};

				// loop through each of the nested object's fields and populate the new object accordingly
				dataObj.fields.forEach(function (dataField, dataFieldI) {

					// console.log('AUTO POP FIELD:', d.prop);
					if (relatedItem.autoPop === '') {
						relatedItemData[dataField.prop] = '';
					} else {
						const popArr = dataField.autoPop.split(':');
						if (popArr[2] === undefined) {
							relatedItemData[dataField.prop] = relatedItem[popArr[1]];
						}
						if (popArr[2] !== undefined && popArr[3] === undefined) {
							relatedItemData[dataField.prop] = relatedItem[popArr[2]];
						}
						if (popArr[3] !== undefined) {
							relatedItemData[dataField.prop] = relatedItem[popArr[2]][popArr[3]];
						}
					}
				});

				// push the new object created from each selected table row
				// into the array named after the data objects prop param
				modalFormData[dataObj.prop].push(relatedItemData);

			});

		});

		// for each of the data config fields
		self.dataConfig.fields.forEach(function (d, i) {
			// create a data property if it is undefined
			if (modalFormData[d.prop] === undefined) {
				modalFormData[d.prop] = '';
			}
		});

		console.log('MODAL FORM DATA', modalFormData);
		this.formData = modalFormData;
	}

	cancelConfirmationModal() {
		this.showConfirmationModal = false;
	}

	showConfirmation() {
		this.showConfirmationModal = true;
	}
}

